/**
 * @desc 修改文章
 */
import { NewsEntity, NewsForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateNewsParameter = NewsForm

const method = 'PUT'
const url = '/content/operation/news'

export const updateNewsApi = (
  data?: UpdateNewsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<NewsEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateNewsApi.method = method
updateNewsApi.url = url
